// src/pages/CopyrightPage.js
import { useNavigate } from 'react-router-dom';
import './LegalPage.css';

function CopyrightPage() {
  const navigate = useNavigate();
  return (
    <div>
      <div className="page-header">
        <button className="page-title-btn" onClick={() => navigate('/')}>
          <img src="/logo.png?v=2" alt="" className="header-logo" />
          PlantID Game
        </button>
      </div>
      <div className="legal-content">
        <h1>Copyright / Urheberrecht</h1>

        <section className="legal-section">
          <h2>English</h2>
          <h3>Copyright &amp; Licensing</h3>
          <p>The source code, design and name of this website are protected by copyright.</p>
          <p>
            Plant images and observation data displayed on this website are sourced from iNaturalist
            and are subject to the respective license terms specified there (e.g., Creative Commons).
          </p>
          <p>Copyright for these materials remains with the respective rights holders.</p>
          <p>Attribution and license information are provided in accordance with iNaturalist requirements.</p>
        </section>

        <section className="legal-section">
          <h2>Deutsch</h2>
          <h3>Urheberrecht &amp; Lizenzen</h3>
          <p>Der Quellcode, das Design und der Name dieser Website sind urheberrechtlich geschützt.</p>
          <p>
            Die auf dieser Website dargestellten Pflanzenbilder und Beobachtungsdaten stammen von iNaturalist
            und unterliegen den jeweils dort angegebenen Lizenzbedingungen (z.&nbsp;B. Creative Commons).
          </p>
          <p>Die Urheberrechte an diesen Inhalten liegen bei den jeweiligen Rechteinhabern.</p>
          <p>Lizenz- und Urheberhinweise werden entsprechend den Vorgaben von iNaturalist angegeben.</p>
        </section>
      </div>
    </div>
  );
}

export default CopyrightPage;
